import { Hash, HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import './App.css'
import { HeaderTitleProvider } from './contexts/HeaderTitleContext';
// ----------------------------------------------------------------------

export default function App() {
  return (
    <HelmetProvider>
      <HeaderTitleProvider>
        <HashRouter>
          <ThemeProvider>
            <ScrollToTop />
            <StyledChart />
            <Router />
          </ThemeProvider>
        </HashRouter>
      </HeaderTitleProvider>
    </HelmetProvider>
  );
}
